export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/dare-to-ask-us.828ffed7.gif","height":595,"width":660,"blurWidth":0,"blurHeight":0};